import React, { Component } from "react";
import SwiperManager from "managers/SwiperManager";
import "swiper/dist/css/swiper.css";
import "./style.module.scss";

class Carousel extends Component {
  constructor(props) {
    super(props);
    this.swiperManager = new SwiperManager();

    this.slideWrapper = this.slideWrapper.bind(this);
  }

  componentDidMount() {
    const { uniqueId } = this.props;
    this.swiperManager.start(`#${uniqueId}`);
  }

  componentWillUnmount() {
    this.swiperManager.destroy();
  }

  slideWrapper() {
    const { slides } = this.props;

    return slides.map((slide, i) => (
      <div className="swiper-slide" key={i}>
        {slide}
      </div>
    ));
  }

  render() {
    return (
      <div className="swiper-container">
        <div className="swiper-wrapper align-items-center">
          {this.slideWrapper()}
        </div>
        <div className="swiper-arrows-container">
          <div className="swiper-prev-arrow">
            <img src="/carousel/arrow-sx.svg" />
          </div>
          <div className="swiper-next-arrow">
            <img src="/carousel/arrow.svg" />
          </div>
        </div>
      </div>
    );
  }
}

export default Carousel;



// WEBPACK FOOTER //
// ./src/components/Carousel/index.js